"use client"

import * as React from "react"
// shadcn/ui sidebar provider primitives — used by the AppShell layout to
// wrap the AppSidebar + TopBar + main-content slot. The presentational
// sub-components (Sidebar, SidebarContent, etc.) live in
// `sub-components/AppSidebar.tsx`; `SidebarTrigger` lives in
// `sub-components/TopBar.tsx`.
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"

import { useAppShell } from "./hooks/use-app-shell"
import { AppSidebar } from "./sub-components/AppSidebar"
import { TopBar } from "./sub-components/TopBar"
import { AdCardSidebar } from "@/components/ads/AdSlot"
import { AIAssistantHub } from "@/components/ai/ai-assistant-hub"
import { WelcomePopup } from "@/components/shared/welcome-popup"
import { useAuth } from "@/lib/use-auth"

// ---------------------------------------------------------------------------
// AppShell — the main shell that wraps authenticated pages
// ---------------------------------------------------------------------------

export function AppShell({ children }: { children: React.ReactNode }) {
  useAppShell()

  // v136: Welcome popup for new users without a profile name (digital card)
  const { user } = useAuth();
  const hasProfileName = !!(user?.profile?.name);
  const userId = user?.id ?? '';

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <TopBar />
        <div id="main-content" role="main" className="flex-1 overflow-auto p-4 md:p-6">
          {children}
          <AdCardSidebar />
        </div>
        <AIAssistantHub />
        {userId && (
          <WelcomePopup hasProfileName={hasProfileName} userId={userId} />
        )}
      </SidebarInset>
    </SidebarProvider>
  )
}
